document.addEventListener('click', (event) => {
  const trigger = event.target instanceof Element
    ? event.target.closest('[data-goldique-legal-guarantee-trigger]')
    : null;
  if (!trigger) return;

  const targetId = decodeURIComponent(trigger.hash.slice(1));
  const target = document.getElementById(targetId);
  if (!(target instanceof HTMLDetailsElement)) return;

  target.open = true;
  requestAnimationFrame(() => target.querySelector('summary')?.focus({ preventScroll: true }));
});
